var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('a-upload',{attrs:{"name":"file","showUploadList":false,"beforeUpload":_vm.beforeUpload}},[_c('a-button',[_vm._v("导入CSV")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }